/* Filter Options */
export interface OptionType {
  id: number,
  name: string,
  note?: string,
  checked?: boolean
}

export interface OnOffGridOptionType extends OptionType {
  Category?: number
}
export interface RotationOptionType extends OptionType {
  year?: string
}

export interface RegionOptionType extends OptionType {
  main?: number,
  coverWholeAlberta?: number,
  subregion?: OptionType[]
}

export type FilterOptionType= {
  region?: RegionOptionType[],
  rotation?: RotationOptionType[],
  onOffGrid?: OnOffGridOptionType[],
  multipleVisit?: OnOffGridOptionType[]
}

export type filterOptionKey = keyof FilterOptionType;

/* Data Category */
interface SubProtocolType extends OptionType {
  last_year: number,
  next_release: string,
  start_year: number,
}
export interface ProtocolType {
  name: string,
  protocol: string,
  note: string,
  detail: SubProtocolType[],
  checked?: boolean,
  id?: number
}

export interface RawdataDownloadParamType {
  offgridId: number[] | string[],
  rawdata: number[] | string[],
  region?: number[] | string[],
  rotation: number[] | string[]
}

export interface RawdataDownloadParamAPIType {
  offgridId: number | string,
  rawdata: number[] | string[],
  region?: number[] | string[],
  rotation: number[] | string[]
}
/* */
export const landbase = ['Terrestrial', 'Wetland'];
export const dataType = ['Species', 'Habitat'];
